import React from 'react'
// import {Link} from 'gatsby'
import mainBanner from '../../components/App/assets/images/banner/banner-main2.png'

const MainBanner = () => {
    return (
        <div id="home" className="banner-area-two">
            <div className="banner-shape-img">
                <img src={mainBanner} alt="Shape" />
            </div>

            <div className="d-table">
                <div className="d-table-cell">
                    <div className="container">

                        <div className="banner-content">
                            <span>Welcome To</span>
                            <h1>Niyant's World</h1>
                            {/* <Link to="#" className="common-btn two">
                                Start A Project
                            </Link> */}

                            <ul>
                                <li>
                                    <a href="https://www.linkedin.com/in/niyantshah02/" rel="noreferrer" target="_blank">
                                        <i className='bx bxl-linkedin'></i>
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.behance.net/niyantshah" rel="noreferrer" target="_blank">
                                        <i className='bx bxl-behance'></i>
                                    </a>
                                </li>
                                <li>
                                    <a href="https://github.com/niyant02" rel="noreferrer" target="_blank">
                                        <i className='bx bxl-github'></i>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default MainBanner